import { colors } from '@utils/utility-property';

export const INITIAL_VALUES = {
  name: '',
  color: colors.green,
};
